<template>
    <div class="carousel">
        <div v-for="(data, i) in doc.bloglist['all'].slice(-4).reverse()" :key="i" class="item"  @click="jump(data.url)">
            <div>
                <img :src="data.poster" alt="">
            </div>
            <div>
                <h3>{{ data.title }}</h3>
            </div>
            <div>
                {{data.desc}}
            </div>
            <div class="column" @click.stop="jump(data.link)">
                {{data.column}}
            </div>
        </div>
    </div>
</template>
<script>
import doc from "@/documents/blogs.js"
export default {
    name: 'Carousel',
    data() {
        return {
            doc: doc,
        }
    },
    methods: {
        jump(link){
            console.log(link);
            window.location.href = link;
        }
    }
}
</script>
<style scoped lang="scss">
.carousel{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px 24px;
    margin-bottom: 30px;
}
.item{
    padding: 20px;
    background: #f8f8f8;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    &:hover{
        transform: translateY(-4px);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    }
}
.column{
    margin-top: 30px;
    font-size: 15px;
    color: #0070c9;
    text-align: center;
    &:hover{
        color: rgb(0, 112, 201, 0.5);
    }
}
@media (max-width: 768px){
    .carousel{
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>